import React from "react";
import useStyles from '../../assets/js/useStyles';


function SvgStick(props) {
    const classes = useStyles();
    return (
        <>
            <div style={{paddingRight:'10px', paddingBottom:'10px'}} className={classes.containerStick}>
                <p className={classes.centeredStick + " mb-2"} >{props.name}</p>
                {
                    props.status === 'wait' ?
                        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                             className={classes.svgStick} viewBox="0 0 640.000000 1280.000000"
                             preserveAspectRatio="xMidYMid meet">
                            <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
                               fill="#000000" stroke="none">
                                <path d="M3023 12785 c-148 -27 -275 -78 -400 -161 -406 -270 -567 -793 -382
-1248 93 -230 295 -441 522 -546 269 -125 604 -124 872 4 526 252 743 873 485
1391 -201 406 -659 640 -1097 560z"/>
                                <path d="M2175 10535 c-257 -48 -477 -209 -595 -436 -41 -80 -63 -150 -390
-1284 -214 -742 -397 -1376 -530 -1835 -258 -890 -270 -935 -270 -1020 0 -145
61 -274 163 -344 77 -53 130 -69 227 -70 77 -1 92 2 152 32 78 38 155 117 197
201 16 31 115 331 220 666 106 336 280 889 388 1230 107 341 201 630 209 643
8 12 21 22 29 22 40 0 42 -18 64 -790 l21 -745 -425 -3187 c-234 -1753 -425
-3218 -425 -3255 1 -119 59 -226 162 -296 96 -65 126 -69 495 -65 l328 3 60
28 c79 37 156 114 190 189 21 46 32 101 50 246 13 103 92 727 175 1387 83 660
182 1448 220 1750 218 1725 300 2384 300 2400 0 10 2 16 5 13 6 -5 8 -24 185
-1433 77 -616 170 -1349 205 -1630 35 -280 125 -994 200 -1586 74 -592 141
-1095 149 -1117 34 -94 109 -176 205 -221 l56 -26 355 0 355 0 67 33 c111 54
187 156 209 279 10 53 -27 340 -419 3283 l-430 3225 9 270 c5 149 15 483 23
744 16 506 17 512 65 496 24 -7 -14 108 471 -1435 183 -580 347 -1084 364
-1120 40 -84 126 -172 203 -208 50 -23 70 -27 143 -26 103 1 178 27 253 88 95
77 157 239 142 371 -4 33 -68 269 -142 525 -268 927 -414 1435 -563 1950 -384
1329 -440 1520 -464 1574 -86 193 -268 365 -467 440 -150 56 -149 56 -1178 55
-732 -1 -962 -4 -1016 -14z"/>
                            </g>
                        </svg> :
                        props.status === 'yard'?
                            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                 className={classes.svgStick} viewBox="0 0 640.000000 1280.000000"
                                 preserveAspectRatio="xMidYMid meet">

                                <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
                                   fill="#000000" stroke="none">
                                    <path d="M3032 12785 c-235 -43 -425 -145 -587 -316 -394 -416 -375 -1077 43
-1470 263 -249 634 -341 992 -248 109 28 281 117 377 194 326 261 464 697 348
1099 -95 329 -342 588 -661 697 -164 56 -356 72 -512 44z"/>
                                    <path d="M1700 10489 c-171 -12 -321 -54 -482 -134 -420 -210 -695 -620 -738
-1099 -8 -84 -10 -633 -8 -1776 l3 -1655 22 -65 c41 -120 122 -213 229 -262
41 -20 66 -23 159 -23 101 0 115 2 170 29 113 56 196 165 227 298 10 41 13
404 13 1650 l0 1598 248 0 247 0 0 -4257 c0 -3707 2 -4267 15 -4328 56 -268
297 -464 571 -465 79 0 200 31 277 72 90 48 195 156 241 248 70 144 66 -51 66
2698 l0 2482 245 0 245 0 0 -2487 c1 -2740 -4 -2551 65 -2689 66 -134 180
-234 333 -292 58 -22 82 -26 187 -26 105 0 129 4 187 26 153 58 267 158 332
290 71 144 66 -238 66 4471 l0 4257 245 0 245 0 0 -1588 c0 -1098 3 -1607 11
-1648 26 -141 106 -252 227 -311 71 -36 81 -38 166 -37 68 0 104 6 144 21 142
57 237 186 262 359 13 95 13 3229 0 3384 -54 610 -476 1102 -1055 1232 -64 14
-139 21 -260 24 -305 7 -2807 10 -2905 3z"/>
                                </g>
                            </svg> :

                            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                             className={classes.svgStick} viewBox="0 0 757.000000 1280.000000"
                             preserveAspectRatio="xMidYMid meet">
                            <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
                               fill="#000000" stroke="none">
                                <path d="M4096 12780 c-372 -69 -652 -280 -802 -606 -87 -187 -116 -442 -74
-644 128 -621 764 -987 1364 -786 459 154 758 614 708 1090 -16 148 -42 239
-107 371 -104 210 -264 370 -480 477 -91 46 -147 64 -291 93 -137 29 -182 29
-318 5z"/>
                                <path d="M3757 10445 c-209 -35 -376 -118 -601 -299 -856 -688 -2047 -1660
-2068 -1688 -73 -95 -76 -107 -321 -1208 -130 -580 -239 -1078 -242 -1106 -10
-74 11 -184 51 -263 66 -133 200 -229 350 -251 212 -32 432 111 510 332 7 21
101 440 209 931 108 490 198 899 201 908 4 16 713 595 741 606 8 3 13 -2 13
-16 0 -11 -254 -1145 -564 -2520 l-565 -2501 -687 -1152 c-411 -689 -699
-1183 -717 -1227 -64 -166 -76 -266 -47 -398 44 -199 152 -363 308 -464 90
-59 151 -83 288 -110 103 -20 108 -20 192 -4 116 23 184 48 266 97 75 44 185
148 233 218 88 131 1513 2549 1563 2653 l60 122 177 823 c153 708 180 822 195
820 17 -3 1517 -1636 1530 -1666 4 -10 114 -575 243 -1257 130 -682 241 -1258
246 -1280 50 -188 207 -379 382 -465 69 -34 241 -80 300 -80 59 0 243 47 312
80 188 90 338 279 380 478 32 154 26 201 -115 949 -72 378 -187 985 -256 1348
-68 363 -129 676 -135 695 -39 126 -38 125 -1006 1269 -519 613 -943 1122
-943 1132 0 22 467 2077 475 2090 4 5 10 9 15 9 6 0 102 -184 215 -409 166
-333 213 -419 252 -460 59 -62 1607 -1131 1700 -1172 178 -81 371 -51 514 79
66 60 110 138 138 244 26 97 26 114 0 202 -29 95 -59 153 -111 210 -27 30
-311 231 -782 556 l-740 509 -538 1066 c-361 715 -554 1087 -585 1128 -261
341 -651 507 -1036 442z"/>
                            </g>
                            </svg>
                }

            </div>
        </>
    );
}

export default SvgStick;